import { useCallback, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { buildTree } from "@/lib/tree";

export function usePersons() {
  const [persons, setPersons] = useState(null);
  const load = useCallback(() => api.get("/persons").then(({ data }) => setPersons(data)), []);
  useEffect(() => { load(); }, [load]);
  const t = useMemo(() => buildTree(persons || []), [persons]);
  return { persons, t, reload: load };
}
